module.exports = __webpack_public_path__ + "static/img/image-phone.38296ea.png";